/**
 * Auth redirect helper — sends the browser to the central login on
 * www.knowledgegate.ai with a `returnTo` pointing back at the current
 * admin URL. After successful login, the main site's auth flow reads
 * the returnTo and redirects here; the cookie set on .knowledgegate.ai
 * is visible to admin.knowledgegate.ai without a re-login step.
 */

const LOGIN_ORIGIN = "https://www.knowledgegate.ai";
const LOGIN_PATH = "/auth/login";

export function buildLoginUrl(): string {
  const returnTo = encodeURIComponent(window.location.href);
  return `${LOGIN_ORIGIN}${LOGIN_PATH}?returnTo=${returnTo}`;
}

export function redirectToLogin(): void {
  // window.location.replace so the failed-auth page isn't in back-button
  // history — confusing otherwise.
  window.location.replace(buildLoginUrl());
}
